const formatDate = (value, locale, options) => {
  if (value) {
    return value.toLocaleDateString(locale, options)
  }
}

const truncate = (text, length, clamp) => {
  clamp = clamp || '...'
  let node = document.createElement('div')
  node.innerHTML = text
  let content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

const intlFormat = (num) => {
  return new Intl.NumberFormat().format(Math.round(num * 100) / 100)
}
const formatNumber = (num) => {
  if (num >= 1000000) {
    return intlFormat(num / 1000000) + 'M'
  }
  if (num >= 1000) {
    return intlFormat(num / 1000) + 'k'
  }
  return intlFormat(num)
}

export {
  formatDate,
  truncate,
  formatNumber
}



// WEBPACK FOOTER //
// ./src/utils/filters.js